'use client';

import { SpeedInsights } from '@vercel/speed-insights/next';

export function SpeedInsightsScript() {
  return <SpeedInsights />;
}
